module.exports = __webpack_public_path__ + "site/img/46.feff11af.jpg";